<template>
  <div class="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 card-hover">
    <div class="p-6">
      <div class="flex items-center mb-6">
        <div class="w-12 h-12 bg-gradient-to-br from-primary-500 to-indigo-600 rounded-xl flex items-center justify-center text-white flex-shrink-0">
          <ScissorsIcon class="w-6 h-6" />
        </div>
        <div class="ml-4">
          <h3 class="text-xl font-bold text-gray-900">Image Cropper</h3>
          <p class="text-sm text-gray-500">Crop, resize, and export</p>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
        <div class="lg:col-span-3">
          <CropperCanvas
            ref="cropperRef"
            :image-data="imageData"
            :aspect-ratio="selectedSize.ratio"
            @ready="handleCropperReady"
            @upload="handleUpload"
          />
        </div>

        <div class="space-y-4">
          <SizeSelector
            v-model="selectedSize"
            :preset-sizes="presetSizes"
          />

          <ExportPanel
            :cropper-ready="cropperReady"
            :image-name="imageName"
            :selected-size="selectedSize"
            @export="handleExport"
            @reset="handleReset"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { ScissorsIcon } from '@heroicons/vue/24/outline'
import Uploader from './Uploader.vue'
import CropperCanvas from './CropperCanvas.vue'
import SizeSelector from './SizeSelector.vue'
import ExportPanel from './ExportPanel.vue'

const cropperRef = ref(null)
const imageData = ref(null)
const imageName = ref('')
const cropperReady = ref(false)

const selectedSize = reactive({
  name: 'Custom',
  width: 800,
  height: 600,
  ratio: null,
  unit: 'px'
})

watch(selectedSize, (newVal) => {
  console.log('selectedSize changed to:', newVal)
}, { deep: true })

const presetSizes = [
  { name: 'Free Ratio', width: null, height: null, ratio: null },
  { name: 'Square 1:1', width: 1080, height: 1080, ratio: 1 },
  { name: 'Avatar 200x200', width: 200, height: 200, ratio: 1 },
  { name: 'Avatar 400x400', width: 400, height: 400, ratio: 1 },
  { name: 'Instagram 1:1', width: 1080, height: 1080, ratio: 1 },
  { name: 'Instagram 4:5', width: 1080, height: 1350, ratio: 4/5 },
  { name: 'Twitter Header 16:9', width: 1500, height: 500, ratio: 16/9 },
  { name: 'YouTube Thumbnail 16:9', width: 2560, height: 1440, ratio: 16/9 },
  { name: 'LinkedIn Banner 16:9', width: 1584, height: 396, ratio: 4 },
  { name: 'Facebook Cover 16:9', width: 820, height: 312, ratio: 820/312 },
  { name: 'A4 Paper', width: 2480, height: 3508, ratio: 2480/3508 },
  { name: '1920x1080', width: 1920, height: 1080, ratio: 16/9 },
  { name: '1280x720', width: 1280, height: 720, ratio: 16/9 },
]

const handleUpload = (data) => {
  imageData.value = data.data
  imageName.value = data.name
  cropperReady.value = false
}

const handleCropperReady = () => {
  cropperReady.value = true
}

const handleExport = (options) => {
  console.log('handleExport called with:', options)
  console.log('Current selectedSize:', selectedSize)
  if (cropperRef.value) {
    cropperRef.value.export(options)
  }
}

const handleReset = () => {
  imageData.value = null
  imageName.value = ''
  cropperReady.value = false
}
</script>
